import {
  CLIENT,
  Device,
  REMOTE,
  SIP,
  SIP_GATEWAY,
  TEAM,
} from "callable-data-objects";
import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const isEndpoint = (type: string) => {
  return [TEAM, REMOTE, SIP, CLIENT, SIP_GATEWAY].indexOf(type) > -1;
};

const HuntGroupSelect = ({ devices, label, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  const options = devices
    .filter((d: Device) => isEndpoint(d.type))
    .map((d: Device) => {
      return { text: d.name, key: d.id, value: d.id };
    });
  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        label={label}
        clearable
        fluid
        search
        selection
        multiple
        options={options}
        name={field.name}
        defaultValue={field.value}
        placeholder='Select Endpoints'
        onChange={(event, { value }) => {
          helpers.setValue(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default HuntGroupSelect;
